import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onBeforeMount, ref } from 'vue'

import type { UserDocListItem } from '@/models/interfaces'
import type { DocsView } from '@/models/doc'
import { DocFavoriteView } from '@/models/doc.favorite'
import { assertNotNull } from '@/helpers/typing'


export default /*@__PURE__*/_defineComponent({
  __name: 'FavoriteFlag',
  props: {
    doc: {},
    docsView: {}
  },
  setup(__props: any) {

const props = __props

const view = ref<DocFavoriteView | null>(null)

onBeforeMount(() => {
  view.value = new DocFavoriteView(props.doc, props.docsView)
})

const flagClass = computed(() => {
  return props.doc.user.is_favorite
    ? 'collection__icon collection__icon--active iconfont iflag2'
    : 'collection__icon iconfont iflag'
})

/**
 * Click handler.
 *
 * We did use the CSS property `:disabled` to prevent the favorite toggle
 * being clicked too often, but if the user clicks favorite button twice,
 * the book is being opened, which is not the behavior we want. This was
 * happening because the disabled button still propagates event to the
 * parent, which is book card.
 *
 * Instead of disabling the button via CSS, we just stop the
 * event propagation and do nothing in the click handler.
 */
async function favoriteToggle($event: Event): Promise<void> {
  if (view.value?.buttonDisabled) {
    return
  }
  await assertNotNull(view.value).favoriteToggle($event)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "favorite-flag",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (favoriteToggle($event)), ["stop","prevent"]))
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(flagClass.value)
    }, null, 2)
  ]))
}
}

})